import Principal from '@app/model/authentication/Principal';
import { GET_CURRENT_PRINCIPAL_QUERY } from '@app/model/authentication/service/AuthorizationGraphQLQueries';
import { GraphQLExecutor } from '@app/model/_common/service/GraphQLExecutor';


class AuthorizationService {
    public static findCurrentPrincipal = () => {
        return GraphQLExecutor.execute<Principal>(GET_CURRENT_PRINCIPAL_QUERY)
    }

    public static findCurrentPrincipalWithHeader = (token: string) => {
        return GraphQLExecutor.executeWithHeaders<Principal>(GET_CURRENT_PRINCIPAL_QUERY, undefined, [
            ["authorization", `Bearer ${token}`]
        ])
    }
}

export default AuthorizationService;